
let MouseMixin = {
  methods: {
    consumeMouseEvents () {
      let captureMouseUp = (event) => {
        event.stopPropagation()
        window.removeEventListener('mouseup', captureMouseUp, true)
      }
      window.addEventListener('mouseup', captureMouseUp, true)
      let captureClick = (event) => {
        event.stopPropagation()
        window.removeEventListener('click', captureClick, true)
      }
      window.addEventListener('click', captureClick, true)
    }
  }
}

export default MouseMixin



// WEBPACK FOOTER //
// ./src/components/shared/MouseMixin.js